import {useEffect} from "react"
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import HomePage from "./pages/HomePage/HomePage.jsx"
import DashBoardSubPage from './pages/DashBoardPage/sub-pages/DashBoardSubPage/DashBoardSubPage.jsx';
import ImagesSubPage from './pages/DashBoardPage/sub-pages/ImagesSubPage/ImagesSubPage.jsx';
import UnitsPage from "./pages/UnitsPage/UnitsPage.jsx"
import RecentPage from "./pages/Admin/RecentPage/RecentPage.jsx";
import AppHeader from "./components/NavigationFrame/AppHeader/AppHeader.jsx"
import AppFooter from "./components/NavigationFrame/AppFooter/AppFooter.jsx"
import PrivateRoute from "./components/PrivateRoute/PrivateRoute.jsx"
import AdminRoute from "./components/AdminRoute/AdminRoute.jsx"
import RollOutPage from "./pages/RollOutPage/RollOutPage.jsx"
import { auth } from './firebase';
import { signInWithCustomToken } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useUser, UserProvider } from './contexts/UserContext.js';
import { SecondHeaderProvider } from './contexts/SecondHeaderContext';
import WadeReportPage from './pages/WadeReportPage/WadeReportPage.jsx';
import WadeReportWeekPage from "./pages/WadeReportWeekPage/WadeReportWeekPage.js";
import AdminOverviewPage from "./pages/Admin/AdminOverviewPage/AdminOverviewPage.jsx";
import AdminPage from "./pages/Admin/AdminPage/AdminPage.jsx";
import ScreenMonitoringPage from "./pages/Admin/ScreenMonitoringPage/ScreenMonitoringPage.jsx";
import InferenceTimesPage from "./pages/Admin/InferenceTimesPage/InferenceTimesPage.jsx";
import WeeklyUsagePage from "./pages/Admin/WeeklyUsagePage/WeeklyUsagePage.jsx";
import WeeklyUsageUnitsPage from "./pages/Admin/WeeklyUsageUnitsPage/WeeklyUsageUnitsPage.jsx";
import { RollOutProvider } from './contexts/RollOutContext';
import { ModelProvider } from './contexts/ModelContext';
import WadeReportMonthPageNew from "./pages/WadeReportMonthPageNew/WadeReportMonthPageNew.jsx";
import Warnings from "./components/Warnings/Warnings.jsx";
import DangerousWasteImagesPage from "./pages/DangerousWasteImagesPage/DangerousWasteImagesPage.jsx";
import DangerousWasteSortingListPage from "./pages/DangerousWasteSortingListPage/DangerousWasteSortingListPage.jsx"
import SetupPage from "./pages/SetupPage/SetupPage.jsx";
import SignupPage from "./pages/SignupPage/SignupPage.jsx";
import WelcomePage from "./pages/WelcomePage/WelcomePage.jsx";

const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
};

function App() {
    const [user, loading] = useAuthState(auth);
    const { userData } = useUser();

    useEffect(() => {
        // Get the token from the cookie
        const customToken = getCookie('firebaseAuthToken');
    
        if (customToken) {
          // Sign in with the custom token
          signInWithCustomToken(auth, customToken)
            .then(() => {
            })
            .catch((error) => {
              console.log("Error signing in with custom token: ", error);
            });
        }
    }, []);

    return (
                        <div className="app-content-container">
                            <BrowserRouter>
                                {
                                    user && userData
                                    ? <AppHeader />
                                    : <></>
                                }

                                <Warnings />

                <div className="router-page">
                    <Routes>
                        <Route 
                            path="/"
                            element={
                                <PrivateRoute>
                                    <HomePage />
                                </PrivateRoute>
                            }
                        />
                        <Route 
                            path="/locations"
                            element={
                                <Navigate to="/" />
                            }
                        />
                        <Route 
                            path="/login"
                            element={
                                <Navigate to="/" />
                            }
                        />
                        {/* Public: a sign-up link is opened by someone who has no account yet. */}
                        <Route
                            path="/signup/:companySlug/:token"
                            element={<SignupPage />}
                        />
                        {/* Public: a Welcome Link is opened by someone who has no password yet. */}
                        <Route
                            path="/velkommen/:token"
                            element={<WelcomePage />}
                        />
                        <Route 
                            path="/locations/:locationId"
                            element={
                                <PrivateRoute>
                                    <UnitsPage />
                                </PrivateRoute>
                            }
                        />
                        <Route 
                            path="/locations/:locationId/unit/:unitId/dashboard" 
                            element={
                                <PrivateRoute>
                                    <DashBoardSubPage />
                                </PrivateRoute>
                            }
                        />
                        <Route 
                            path="/unit/:unitId/dashboard" 
                            element={
                                <PrivateRoute>
                                    <DashBoardSubPage />
                                </PrivateRoute>
                            }
                        />
                        <Route 
                            path="/locations/:locationId/unit/:unitId/dashboard/wade-report-mode/month" 
                            element={
                                <PrivateRoute>
                                    <WadeReportMonthPageNew />
                                </PrivateRoute>
                            }
                        />
                        <Route 
                            path="/locations/:locationId/unit/:unitId/dashboard/wade-report-mode/week" 
                            element={
                                <PrivateRoute>
                                    <WadeReportWeekPage />
                                </PrivateRoute>
                            }
                        />
                        <Route 
                            path="/locations/:locationId/unit/:unitId/dashboard/wade-report-mode/week/:weekNumber" 
                            element={
                                <PrivateRoute>
                                    <WadeReportWeekPage />
                                </PrivateRoute>
                            }
                        />
                        <Route 
                            path="/locations/:locationId/unit/:unitId/images" 
                            element={
                                <PrivateRoute>
                                    <ImagesSubPage />
                                </PrivateRoute>
                            }
                        />
                        <Route 
                            path="/locations/:locationId/unit/:unitId/dangerous-waste/:pane" 
                            element={
                                <PrivateRoute>
                                    <DangerousWasteImagesPage />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/app-records/:appOwnerType/:appOwnerId/dangerous-waste/:pane"
                            element={
                                <PrivateRoute>
                                    <DangerousWasteImagesPage />
                                </PrivateRoute>
                            }
                        />
                        <Route 
                            path="/dangerous-waste/sorting-lists" 
                            element={
                                <PrivateRoute>
                                    <DangerousWasteSortingListPage />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="recent"
                            element={
                                <AdminRoute>
                                    <RecentPage />
                                </AdminRoute>
                            }
                        />
                        <Route
                            path="screens"
                            element={
                                <AdminRoute>
                                    <ScreenMonitoringPage />
                                </AdminRoute>
                            }
                        />
                        <Route
                            path="roll-out"
                            element={
                                <AdminRoute>
                                    <RollOutPage />
                                </AdminRoute>
                            }
                        />
                        <Route
                            path="setup"
                            element={
                                <AdminRoute>
                                    <SetupPage />
                                </AdminRoute>
                            }
                        />
                        <Route
                            path="admin-overview"
                            element={
                                <AdminRoute>
                                    <AdminOverviewPage />
                                </AdminRoute>
                            }
                        />
                        <Route
                            path="admin"
                            element={
                                <AdminRoute>
                                    <AdminPage />
                                </AdminRoute>
                            }
                        />
                        <Route
                            path="admin/inference-times"
                            element={
                                <AdminRoute>
                                    <InferenceTimesPage />
                                </AdminRoute>
                            }
                        />
                        <Route
                            path="admin/weekly-usage"
                            element={
                                <AdminRoute>
                                    <WeeklyUsagePage />
                                </AdminRoute>
                            }
                        />
                        <Route
                            path="admin/weekly-usage/units"
                            element={
                                <AdminRoute>
                                    <WeeklyUsageUnitsPage />
                                </AdminRoute>
                            }
                        />
                    </Routes>
                </div>

                                {
                                    <AppFooter />
                                }
                            </BrowserRouter>
                        </div>
    );
}

export default App;
